/**
 * Tela principal da área de billing admin (/admin/billing).
 *
 * Compõe ConfigForm, MultipliersGrid e PlansTable.
 * Acessível apenas para usuários com is_platform_admin=true.
 */
import { ConfigForm } from './ConfigForm';
import { ModelPricesTable } from './ModelPricesTable';
import { MultipliersGrid } from './MultipliersGrid';
import { PlansTable } from './PlansTable';

export function BillingAdminScreen() {
  return (
    <div className="dash-section">
      <div className="dash-section__header">
        <div>
          <h1 className="dash-section__title">Cobrança — Administração</h1>
          <p className="muted">
            Configuração global de billing, multiplicadores, catálogo de planos e preços de modelo.
          </p>
        </div>
      </div>
      <ConfigForm />
      <MultipliersGrid />
      <PlansTable />
      <ModelPricesTable />
    </div>
  );
}
